import { render, staticRenderFns } from "./barra-preguntas-listado-pregunta.vue?vue&type=template&id=19ac1b00&scoped=true&"
import script from "./barra-preguntas-listado-pregunta.vue?vue&type=script&lang=ts&"
export * from "./barra-preguntas-listado-pregunta.vue?vue&type=script&lang=ts&"
import style0 from "./barra-preguntas-listado-pregunta.vue?vue&type=style&index=0&id=19ac1b00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ac1b00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow,VSpacer,VTooltip})
